var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-sn",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b7226",
    d: "M0 0h170.7v512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M170.7 0h170.6v512H170.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bc0000",
    d: "M341.3 0H512v512H341.3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0b7226",
    d: "m197 351.7 22-71.7-60.4-46.5h74.5l24.2-76 22.1 76H356L295.6 280l22.1 74-60.3-46.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSn);
export default __webpack_public_path__ + "static/media/sn.07ec7ccbea282d9458ad56ee5df564bf.svg";
export { ForwardRef as ReactComponent };